/**
 * Created by coolguy on 2017/4/15.
 */
const ENV = process.env.NODE_ENV === 'development';//npm start会将当前环境设置为development
//所以开发环境下用我们线上服务器的；产品环境下用内网的
const PREFIX = ENV ? "/api" : "/api";

const shouldAddPrefix = (url)=>{
    url = url || '';
    return !(/^(https?:)?\/\//.test(url));
}

/*
 GET /user 查询列表
 GET /user/:id 查询单个
 POST /user 新建
 PUT /user/:id 更新
 DELETE /user/:id 删除
 */

//通用的API列表
//eg: Api('user')('get')(5) Api('user')('get')()
//output eg:{url: "XXX/user/5", method: "get"}
const Api = (entity)=>{
    return (verb)=>{
        return (id)=>{
            entity = entity.toLowerCase();
            let url = shouldAddPrefix(entity) ? PREFIX + `/${entity}` : entity;
            if(id!==undefined){
                url += `/${id}`
            }
            return {
                url:url,
                method:verb.toLowerCase()
            }
        }
    }
};
//其他特殊的API

const Login = {
    login: {
        url: PREFIX + "/user/login",
        method: "post"
    },
    logout: {
        url: PREFIX + "/user/logout",
        method: "post"
    }
};
const Image = {
    sign:{
        url: PREFIX + "/image/sign",
        method:"post"
    },
    store:{
        url: "//jfoto-image-current.oss-cn-zhangjiakou.aliyuncs.com/"
    }
};
export default Api;
export {
    Login,
    Api,
    Image,
}



// WEBPACK FOOTER //
// ./src/util/ApiList.js